import { UTILS__image } from '@/utils/UTILS__image';
import { assert_not_null } from '@shared/asserts/utils_asserts';

export async function FN_IMAGE_MASK__is_partially_masked(url_absolute: string, x: number, y: number, width: number, height: number) {
  if (width == 0 || height == 0) return false;

  let image = await UTILS__image.load_from_url(url_absolute);

  const canvas = document.createElement('canvas');
  const ctx = canvas.getContext('2d');
  assert_not_null(ctx);

  [canvas.width, canvas.height] = [image.width, image.height];
  ctx.drawImage(image, 0, 0);

  // 2. Get the pixel data for the entire image (or just the crop area for optimization)
  // For accuracy with your todos, let's look at the specific crop box area
  const image_data = ctx.getImageData(x, y, width, height);
  const pixels = image_data.data; // Flat RGBA array

  let has_black = false;
  let has_white = false;
  let has_other_colors = false;

  // Loop through pixels (step by 4 because of R, G, B, A)
  for (let i = 0; i < pixels.length; i += 4) {
    const [r, g, b, a] = [pixels[i], pixels[i + 1], pixels[i + 2], pixels[i + 3]];

    // Skip fully transparent pixels if they shouldn't count as "black or white"
    if (a === 0) continue;

    if (r === 0 && g === 0 && b === 0) {
      has_black = true;
    } else if (r === 255 && g === 255 && b === 255) {
      has_white = true;
    } else {
      has_other_colors = true; // Found a gray or colored pixel
    }

    // Optimization: If we already found both black and white,
    // or a distinct color, we know it's not *solely* one solid block.
    if ((has_black && has_white) || has_other_colors) {
      return true;
    }
  }

  // 3. If the loop finishes and we only hit one color (or none), return false
  return false;
}
